import Vue, { CreateElement } from 'vue'
import Component from 'vue-class-component'

import { Icon } from '@src/elements/icon/icon'
import { AVAILABLE_LOCALES } from '@src/util/constants'
import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import Cookies from '@src/lib/cookies'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import { OptionGroup } from '@src/elements/select/option-group'
import { Popover } from '@src/components/popover/popover'
import { MenuButton } from '@src/elements/button/button'
import SessionManager from '@src/lib/session_manager'

import './language-switch.sass'

@Component({
  computed: {
    locale () {
      return this.$store.state.i18n.locale
    }
  }
})
export class LanguageSwitch extends Vue {

  protected locale: string
  private apiClient: ApiClient = new ApiClient()

  constructor () {
    super()
    let storedLocale = Cookies.get('Locale')
    if (storedLocale && AVAILABLE_LOCALES.includes(storedLocale)) {
      this.$store.dispatch('switchLanguage', storedLocale)
    } else {
      Cookies.set('Locale', 'en-gb', { expires: '5Y' })
    }
  }

  changeLanguage (locale) {
    if (this.$store.state.user) {
      return this.apiClient.put(SessionManager.Instance.isManager() ? API.TRAINERS_API.PROFILE : API.MEMBERS_API.PROFILE, { profile: ({ locale: locale }) })
        .then(() => {
          this.$store.dispatch('switchLanguage', locale)
          Cookies.set('Locale', locale, { expires: '5Y' })
        })
        .catch((error) => console.log('error updating language in profile settings', error))
    } else {
      this.$store.dispatch('switchLanguage', locale)
      Cookies.set('Locale', locale, { expires: '5Y' })
    }
  }

  closeLanguages () {
    this.$store.dispatch('switchLanguage', this.locale)
    Cookies.set('Locale', this.locale, { expires: '5Y' })
  }

  render (h: CreateElement) {
    const languages = AVAILABLE_LOCALES.map(locale => {
      return <div onClick={() => this.changeLanguage(locale)} class='locale-row' ref={locale}>
        <Icon name={`country-flags/${locale}`} />
        <Subtitle1>{this.$t(`LANGUAGES.${locale}`)}</Subtitle1>
      </div>
    })

    return <MenuButton class='language-wrapper'>
      <div slot='button' class='language-label'>
        <Icon name={`country-flags/${this.locale}`} class='locale-flag' />
        <div class='switch-label'>
          <div class='vertical-separator' />
          <Subtitle2>{this.$t('SWITCH_LANGUAGE')}</Subtitle2>
        </div>
      </div>

      <Popover>
        <div class='scroll-summary'>
          <OptionGroup>
            <div class='settings-back-arrow-wrapper'>
              <Icon name={'util/back-arrow'} class='logo' click={this.closeLanguages} />
            </div>
            {languages}
          </OptionGroup>
        </div>
      </Popover>
    </MenuButton>
  }
}

@Component
export class IconLanguageSwitch extends LanguageSwitch {

  render (h: CreateElement) {
    const languages = AVAILABLE_LOCALES.map(locale => {
      return <div onClick={() => this.changeLanguage(locale)} class='locale-row' ref={locale}>
        <Icon name={`country-flags/${locale}`} />
        <Subtitle1>{this.$t(`LANGUAGES.${locale}`)}</Subtitle1>
      </div>
    })

    return <MenuButton class='language-wrapper icon-language-wrapper'>
      <div slot='button' class='language-label'>
        <Icon name={`country-flags/${this.locale}`} class='locale-flag' />
      </div>

      <Popover>
        <div class='scroll-summary'>
          <OptionGroup>
            <div class='settings-back-arrow-wrapper'>
              <Icon name={'util/back-arrow'} class='logo' click={this.closeLanguages} />
            </div>
            {languages}
          </OptionGroup>
        </div>
      </Popover>
    </MenuButton>
  }
}
